import React from 'react'
import { Form, Input, Button, Select, Divider, App, Alert } from 'antd'
import { UserOutlined, MailOutlined, LockOutlined, PhoneOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router'
import { useLanguage } from 'src/providers/LanguageProvider'
import api from 'src/services/api'

const RegisterForm = () => {


    const { t } = useLanguage()
    const navigate = useNavigate()
    const [loading, setLoading] = React.useState(false)
    const message = App.useApp().message;

    const [validationErrors, setValidationErrors] = React.useState([])


    const onFinish = async (values) => {
        setValidationErrors([]); // Önceki doğrulama hatalarını temizle
        const payload = {
            Email: values.Email,
            Password: values.Password,
            FirstName: values.FirstName,
            LastName: values.LastName,
            Country: values.Country,
            Language: values.Language,
            Phone: values.Phone,
        };
        try {
            setLoading(true);
            const response = await api.post("/auth/register", payload);

            message.success(t('REGISTER_SUCCESS', 'Hesap oluşturuldu. Aktivasyon işlemleri için adminlerle görüşün.'));
            navigate("/login");
        } catch (err) {


            if (err?.response?.data?.message == 'Validation error') {
                const validationErrors = err?.response?.data?.errors;
                if (validationErrors && Array.isArray(validationErrors)) {
                    validationErrors.forEach(error => {
                        const _message = error.message;
                        const field = error.field;
                        setValidationErrors(prevErrors => [...prevErrors, { field, _message }]);
                        message.error(field ? `${t(field.toLowerCase()) ? `${t(field.toLowerCase())}: ` : ''}${t('error.message')}` : t('error.message'));
                    });

                    return; // Tüm hata mesajları gösterildikten sonra çıkış yap
                }
            }
            if (err?.response?.data?.details?.error === 'BACKEND_EMAIL_ALREADY_IN_USE') {
                message.error(t('ERROR_EMAIL_EXISTS', 'Bu e-posta zaten kayıtlı.'))

                setValidationErrors([{ field: 'Email', _message: t('ERROR_EMAIL_EXISTS', 'Bu e-posta zaten kayıtlı.') }]);
                return; // E-posta zaten kayıtlı hatası gösterildikten sonra çıkış yap
            }

            message.error(err?.response?.data?.message || t('REGISTER_FAILED', 'Kayıt başarısız. Lütfen tekrar deneyin.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>

            {
                validationErrors.map((error, index) => (
                    <Alert type='error' banner style={{ marginBottom: 16 }} message={
                        <div>
                            <div key={index}>{error._message}</div>
                        </div>
                    } />
                ))
            }
            <Form
                name="register"
                layout="vertical"
                autoComplete="off"
                requiredMark="optional"
                style={{ marginTop: 20 }}
                onFinish={onFinish}
            >
                <Form.Item
                    label={t('LABEL_FIRSTNAME', 'Ad')}
                    name="FirstName"
                    rules={[
                        { required: true, message: t('ERROR_FIRSTNAME_REQUIRED', 'Ad zorunludur') },
                        { min: 2, message: t('ERROR_FIRSTNAME_MIN', 'Ad en az 2 karakter olmalı') },
                        { max: 50, message: t('ERROR_FIRSTNAME_MAX', 'Ad en fazla 50 karakter olmalı') },
                        {
                            pattern: /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]+$/,
                            message: t('ERROR_FIRSTNAME_ONLY_LETTERS', 'Sadece harf girin'),
                        },
                    ]}
                >
                    <Input size="large" prefix={<UserOutlined />} placeholder={t('PLACEHOLDER_FIRSTNAME', 'Ad')} allowClear />
                </Form.Item>

                <Form.Item
                    label={t('LABEL_LASTNAME', 'Soyad')}
                    name="LastName"
                    rules={[
                        { required: true, message: t('ERROR_LASTNAME_REQUIRED', 'Soyad zorunludur') },
                        { min: 2, message: t('ERROR_LASTNAME_MIN', 'Soyad en az 2 karakter olmalı') },
                        { max: 50, message: t('ERROR_LASTNAME_MAX', 'Soyad en fazla 50 karakter olmalı') },
                        {
                            pattern: /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]+$/,
                            message: t('ERROR_LASTNAME_ONLY_LETTERS', 'Sadece harf girin'),
                        },
                    ]}
                >
                    <Input size="large" prefix={<UserOutlined />} placeholder={t('PLACEHOLDER_LASTNAME', 'Soyad')} allowClear />
                </Form.Item>

                <Form.Item
                    label={t('LABEL_EMAIL', 'E-posta')}
                    name="Email"
                    rules={[
                        { required: true, message: t('ERROR_EMAIL_REQUIRED', 'E-posta gerekli') },
                        { type: 'email', message: t('ERROR_EMAIL_INVALID', 'Geçerli bir e-posta girin') },
                    ]}
                >
                    <Input size="large" prefix={<MailOutlined />} placeholder={t('PLACEHOLDER_EMAIL', 'ornek@site.com')} inputMode="email" allowClear />
                </Form.Item>

                <Form.Item
                    label={t('LABEL_PASSWORD', 'Şifre')}
                    name="Password"
                    rules={[
                        { required: true, message: t('ERROR_PASSWORD_REQUIRED', 'Şifre gerekli') },
                        {
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const minLength = /.{8,}/;
                                const upperCase = /[A-Z]/;
                                const lowerCase = /[a-z]/;
                                const number = /[0-9]/;
                                const specialChar = /[!@#$%^&*(),.?":{}|<>]/;

                                if (!minLength.test(value)) {
                                    return Promise.reject(new Error(t('ERROR_MIN8', 'En az 8 karakter olmalı')));
                                }
                                if (!upperCase.test(value)) {
                                    return Promise.reject(new Error(t('ERROR_UPPERCASE', 'En az 1 büyük harf olmalı')));
                                }
                                if (!lowerCase.test(value)) {
                                    return Promise.reject(new Error(t('ERROR_LOWERCASE', 'En az 1 küçük harf olmalı')));
                                }
                                if (!number.test(value)) {
                                    return Promise.reject(new Error(t('ERROR_NUMBER', 'En az 1 rakam olmalı')));
                                }
                                if (!specialChar.test(value)) {
                                    return Promise.reject(new Error(t('ERROR_SPECIALCHAR', 'En az 1 özel karakter olmalı')));
                                }

                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Input.Password
                        size="large"
                        prefix={<LockOutlined />}
                        placeholder={t('PLACEHOLDER_PASSWORD')}
                    />

                </Form.Item>

                <Form.Item
                    label={t('LABEL_PHONE', 'Telefon')}
                    name="Phone"
                    rules={[
                        {
                            pattern: /^(\+?\d{1,3})?\s?\d{6,14}$/,
                            message: t('ERROR_PHONE_INVALID', 'Geçerli bir telefon numarası girin'),
                        },
                    ]}
                >
                    <Input size="large" prefix={<PhoneOutlined />} placeholder={t('PLACEHOLDER_PHONE', '+31 6 ...')} allowClear />
                </Form.Item>

                <Form.Item
                    label={t('LABEL_COUNTRY', 'Ülke')}
                    name="Country"
                    rules={[
                        { required: true, message: t('ERROR_COUNTRY_REQUIRED', 'Ülke seçin') },
                    ]}
                >
                    <Select
                        size="large"
                        options={[
                            { value: 'TR', label: t('COUNTRY_TR') },
                            { value: 'NL', label: t('COUNTRY_NL') },
                            { value: 'DE', label: t('COUNTRY_DE') },
                            { value: 'FR', label: t('COUNTRY_FR') },
                            { value: 'BE', label: t('COUNTRY_BE') },
                            { value: 'PL', label: t('COUNTRY_PL') }
                        ]}
                        placeholder={t('PLACEHOLDER_COUNTRY', 'Ülke seçin')}
                        allowClear
                    />
                </Form.Item>

                <Form.Item
                    label={t('LABEL_LANGUAGE', 'Dil')}
                    name="Language"
                    rules={[
                        { required: true, message: t('ERROR_LANGUAGE_REQUIRED', 'Dil seçin') },
                    ]}
                >
                    <Select
                        size="large"
                        options={[
                            { value: "NL", label: t('LANG_NAME_NL', 'Dutch') },
                            { value: "TR", label: t('LANG_NAME_TR', 'Türkçe') },
                            { value: "EN", label: t('LANG_NAME_EN', 'English') },
                            { value: "DE", label: t('LANG_NAME_DE', 'Deutsch') },
                            { value: "FR", label: t('LANG_NAME_FR', 'Français') },
                        ]}
                        placeholder={t('PLACEHOLDER_LANGUAGE', 'Dil seçin')}
                        allowClear
                    />
                </Form.Item>

                <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    block
                    loading={loading}
                    aria-label={t('BTN_REGISTER')}
                >
                    {t('BTN_REGISTER')}
                </Button>


                <Divider plain>{t('WORD_OR', 'veya')}</Divider>

                <Button size="large" icon={<ArrowLeftOutlined />} block onClick={() => navigate("/login")}>
                    {t('BACK_TO_LOGIN', 'Giriş sayfasına dön')}
                </Button>
            </Form>

        </>
    )
}

export default RegisterForm